// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yZhfK","label":"styles_label__2ROZN"};